import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { PRODUCTS_ROUTE, GOODIE_ROUTE, PROFILE_ROUTE, COMMUNITY_ROUTE, COMMUNITY_INTEREST_PROFILE_ROUTE } from '@mwe/constants';

@Injectable({
  providedIn: 'root',
})
export class HelperService {
  private router = inject(Router);

  isCommunityPath(): boolean {
    return this.router.url.includes(COMMUNITY_ROUTE);
  }

  isCommunityProfilePath(): boolean {
    return this.router.url.includes(COMMUNITY_INTEREST_PROFILE_ROUTE);
  }

  isProductPath(): boolean {
    return this.router.url.indexOf(`/${PRODUCTS_ROUTE}`) !== -1;
  }

  isGoodiePath(): boolean {
    return this.router.url.indexOf(`/${GOODIE_ROUTE}`) !== -1;
  }

  isProfilePath(): boolean {
    return this.router.url.indexOf(`/${PROFILE_ROUTE}`) !== -1;
  }
}
